import { PayloadAction } from '@reduxjs/toolkit';
import { QuoteLineInfoTab } from '@ui/config/price/constants';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

type Params = QuoteLineParams & {
  tab: QuoteLineInfoTab;
};

export function quoteLineInfoTabChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  quoteLine.infoTab = action.payload.tab;
}
